import {
	Box,
	Button, Collapse, Divider,
	Grid,
	IconButton,
	Link,
	TextField,
	Typography,
} from "@material-ui/core";
import ThumbUpIcon from "@material-ui/icons/ThumbUp";
import ThumbDownIcon from "@material-ui/icons/ThumbDown";
import React, { useState } from "react";
import { SubmitFeedbackResponse } from "../../../../services/AssistantService";

export interface Props {
	response: string;
	responseComplete: boolean;
	onSubmit: (feedback?: string, thumbsUp?: boolean) => Promise<SubmitFeedbackResponse>;
}

export function AssistantResponse(props: Props) {
	const { response, responseComplete, onSubmit } = props;

	const [feedback, setFeedback] = useState<string>();
	const [thumbsUp, setThumbsUp] = useState<boolean>();
	const [feedbackSubmitted, setFeedbackSubmitted] = useState(false);
	const [feedbackAccepted, setFeedbackAccepted] = useState(false);
	const [feedbackError, setFeedbackError] = useState<string>();

	const feedbackDisabled = feedbackSubmitted || (feedback === undefined && thumbsUp === undefined);

	const updateThumbsUp = (value: boolean) => {
		if (thumbsUp === value) setThumbsUp(undefined);
		else setThumbsUp(value);
	}

	const submit = async () => {
		setFeedbackSubmitted(true);
		let response = await onSubmit(feedback, thumbsUp);
		setFeedbackAccepted(response.success);

		if (!response.success) {
			setFeedbackSubmitted(false);
			setFeedbackError(response.errorMessage);
		}
	}

	return (
		<>
			<Grid container>
				<Grid item xs={12}>
					<Box padding={1}>
						{response.split("\n").map((line, index) => (
							<Typography key={index} variant="body2" color="textPrimary" style={{lineHeight: 1.5, fontSize: "1rem"}} gutterBottom>
								{line}
							</Typography>
						))}
					</Box>
				</Grid>

					<Collapse in={responseComplete} timeout={1000}>
						<Grid item>
							<Box paddingTop={1}>
								<Divider />
							</Box>
						</Grid>

						<Collapse in={!feedbackAccepted} timeout={500}>
							<Grid item xs={12}>
								<Box margin={0.5}>
									<TextField
										placeholder="How was this helpful?"
										multiline
										minRows={6}
										variant="outlined"
										fullWidth
										value={feedback}
										onChange={(e) => setFeedback(e.target.value)}
									/>
								</Box>
							</Grid>

							<Grid item xs={12}>
								<Box display="flex" justifyContent="flex-end" paddingBottom={4}>
									<IconButton
										color={thumbsUp === true ? "primary" : undefined}
										onClick={() => updateThumbsUp(true)}
									>
										<ThumbUpIcon />
									</IconButton>
									<IconButton
										color={thumbsUp === false ? "primary" : undefined}
										onClick={() => updateThumbsUp(false)}
										style={{marginRight: 12}}
									>
										<ThumbDownIcon />
									</IconButton>

									<Button
										color="primary"
										variant={feedbackDisabled ? "outlined" : "contained"}
										disabled={feedbackDisabled}
										onClick={submit}
									>
										Share Feedback
									</Button>
								</Box>

								<Divider />
							</Grid>
						</Collapse>

						<Grid item xs={12}>
							<Box padding={1.5}>
								<Typography variant="subtitle1" color="textPrimary" style={{fontWeight: 500}}>
									USAGE NOTICE
								</Typography>

								<Typography variant="caption" color="textSecondary">
									Suggestions are generated using AI technology, use with caution. Always fact-check any claims, quotes, or reference to historical facts. <Link underline="always" href="https://www.sermoncentral.com/contactus">Report a problem</Link>
								</Typography>
							</Box>
						</Grid>
					</Collapse>
			</Grid>
			</>
	);
}
